import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Zones from "@/components/site/Zones";
import QuoteForm from "@/components/site/QuoteForm";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <Process />
        <Zones />
        <QuoteForm />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
